var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 140,
    height: 140,
    rx: 70,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 140,
    height: 140,
    rx: 70,
    stroke: "#FEF3F2",
    strokeWidth: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 110.833C94.7903 110.833 110.833 94.79 110.833 74.9998C110.833 55.2096 94.7903 39.1665 75.0001 39.1665C55.2099 39.1665 39.1667 55.2096 39.1667 74.9998C39.1667 94.79 55.2099 110.833 75.0001 110.833Z",
    stroke: "#EF4444",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 89.3333V75",
    stroke: "#EF4444",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60.6665H75.0358",
    stroke: "#EF4444",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/FailIcon.2e514aa5b4d46bbc57583325e43e7f3f.svg";
export { ForwardRef as ReactComponent };